export default __webpack_public_path__ + "assets/img/login-mobile.8c3beb9ae4d699f0db3727b1c057fe0a.svg";